<template>
<div class="serviceinfo">
    <el-form :model="item" :rules="rules" ref="ruleForm" label-width="130px" class="demo-item" label-position="left"
             size="mini">
        <el-form-item label="二维码" class="upload-image content" prop="keyurl" required>
            <div class="upload sponsor-logo" @click="openLocalGallery">
                <div class="avatar-uploader">
                    <div tabindex="0" class="el-upload el-upload--text">
                        <i class="avatar-uploader-icon user_default_image"
                           v-if="!item.keyurl"></i>
                        <img :src="item.keyurl+'?'+timestamp" alt="" class="avatar"
                             v-if="item.keyurl">
                    </div>
                </div>
            </div>
        </el-form-item>
        <el-form-item label="联系人" prop="name" class="content">
            <el-input v-model.trim="item.name" placeholder="请输入联系人" clearable></el-input>
        </el-form-item>
        <el-form-item label="客服电话" prop="phone" class="content">
            <el-input v-model.trim="item.phone" placeholder="请输入客服电话" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-button type="primary" @click="submit">确 定</el-button>
        </el-form-item>
    </el-form>
    <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="setImage"
                  :uploadType="uploadType"></localCropper>
</div>
</template>

<script>
import {uploadHostServiceInfo} from 'api/brandBusiness'
import {sendVerCode} from 'api/api'
import LocalCropper from 'base/cropper/localCropper'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'serviceinfo',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择二维码'))
            } else {
                callback()
            }
        }
        return {
            item: {
                hostroletype: 2,
                name: '',
                phone: '',
                keyid: '',
                keyurl: ''
            },
            timestamp: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [110, 110], // 截图框的宽高比例
                enlarge: 1, // 图片根据截图框输出比例倍数
                autoCropWidth: 110, // 默认生成截图框宽度
                autoCropHeight: 110 // 默认生成截图框高度
            },
            rules: {
                keyurl: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ],
                name: [
                    {required: true, message: '请输入联系人', trigger: 'blur'}
                ],
                phone: [
                    {required: true, message: '请输入联系电话', trigger: 'blur'}
                ],
            }
        }
    },
    mounted() {
    },
    methods: {
        init(item) {
            this.item.keyid = item.serviceqrcodeid
            this.item.keyurl = item.serviceqrcodeurl
            this.item.name = item.servicename
            this.item.phone = item.servicetel
        },
        openLocalGallery() {
            this.$refs.localCropper.openDialog()
        },
        setImage(file) {
            this.timestamp = new Date().getTime()
            this.item.keyid = file.key
            this.item.keyurl = file.furl
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认保存', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._save()
                    })
                }
            })
        },
        _save() {
            this.setLoading(true)
            uploadHostServiceInfo({
                data: this.item,
                success: data => {
                    this.$message.success('保存成功')
                    this.setLoading(false)
                    this.$emit('getView')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LocalCropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.serviceinfo {
    .avatar{
        width: 110px;
        height: 110px;
    }
    .user_default_image{
        width: 110px;
        height: 110px;
    }
    .content{
        display: flex;
        align-items: center;
    }
    .el-input{
        line-height: 1;
    }
    .el-form-item__content{
        margin-left: 20px !important;
        .smscode{
            width: 140px;
            margin: 0 20px 0 0;
        }
        .smscode-button{
            margin:0;
        }
        .el-textarea{
            width: 460px !important;
            height: 54px;
        }
    }
}
</style>
